




































































































import { Component, Vue, Prop } from "vue-property-decorator";
import requestService from "@/service/requestService";
import * as util from "@/service/util";
import { MESSAGE } from "@/model/Message";
import { Getter } from 'vuex-class';
import InputNumber from "@/components/common/input/InputNumber.vue";

@Component({
  components: {
    InputNumber
  }
})
export default class tireDialog extends Vue {

  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;

  reqService: requestService;
  showDialog: boolean = false;
  errorMessage: string = "";
  loading: boolean = true;
  loadingText: string = MESSAGE.Loading;

  wizeList1: any = [];
  wizeList2: any = [];
  henpeiList1: any = [];
  henpeiList2: any = [];
  radialList: any = ['R', 'B'];
  inchiList1: any = [];
  inchiList2: any = [];
  indexList: any = [];
  plyRatingList: any = ['P', 'PR'];

  carForm: any = {
    isFront: true,
    wize: null,
    henpei: null,
    inchi: null,
    index: null,
    radial: 'R',
    isWTire: null,
    isKamotsu: false,
    plyRating: null
  };

  created() {
    this.reqService = new requestService();
    this.setList();
  }

  setList() {
    for (let i = 135; i <= 225; i = i + 10) {
      this.wizeList1.push(i);
    }
    for (let i = 235; i <= 325; i = i + 10) {
      this.wizeList2.push(i);
    }
    for (let i = 25; i <= 70; i = i + 5) {
      this.henpeiList1.push(i);
    }
    for (let i = 75; i <= 85; i = i + 5) {
      this.henpeiList2.push(i);
    }
    this.henpeiList2.push('S');
    this.inchiList1.push(10);
    for (let i = 12; i <= 20; i++) {
      this.inchiList1.push(i);
    }
    for (let i = 21; i <= 24; i++) {
      this.inchiList2.push(i);
    }
  }

  onOpen(val: any) {
    this.showDialog = true;
    this.errorMessage = "";
    this.carForm.isFront = val.isFront;
    this.carForm.wize = val.wize;
    this.carForm.henpei = val.henpei;
    this.carForm.inchi = val.inchi;
    if (val.radial) this.carForm.radial = val.radial;
    this.carForm.index = val.index;
    this.carForm.isWTire = val.isWTire;
    this.carForm.isKamotsu = val.isKamotsu;
    if (val.plyRating) {
      this.carForm.plyRating = val.plyRating;
    } else {
      if (this.carForm.isKamotsu) this.carForm.plyRating = 'P';
    }
  }

  onClose() {
    this.showDialog = false;
  }

  setTireFrom() {
    this.$emit("setTireFrom", {
      wize: this.carForm.wize,
      henpei: this.carForm.henpei,
      inchi: this.carForm.inchi,
      radial: this.carForm.radial,
      index: this.carForm.index,
      isWTire: this.carForm.isWTire,
      plyRating: this.carForm.plyRating
    });
    this.showDialog = false;
  }
  setWize(val: any) {
    this.carForm.wize = val;
  }
  setHenpei(val: any) {
    this.carForm.henpei = val;
  }
  setRadial(val: any) {
    this.carForm.radial = val;
  }
  setInchi(val: any) {
    this.carForm.inchi = val;
  }
  setWideTire() {
    if (this.carForm.isWTire === 1) {
      this.carForm.isWTire = null;
    } else {
      this.carForm.isWTire = 1;
    }
  }
  setPlyRating(val: any) {
    this.carForm.plyRating = val;
  }
}
